const COPY_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="8" y="8" width="11" height="11" rx="2"></rect><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2"></path></svg>';

function copyCaption(btn) {
  var textEl = btn.previousElementSibling;
  if (!textEl || !textEl.classList.contains('eng-copy-text')) {
    var item = btn.closest('.eng-copy-item');
    textEl = item ? item.querySelector('.eng-copy-text') : null;
  }
  if (!textEl) return;

  navigator.clipboard.writeText(textEl.innerText.trim()).then(function () {
    btn.innerHTML = '✓';
    setTimeout(function () {
      btn.innerHTML = COPY_ICON;
    }, 1500);
  });
}

document.querySelectorAll('.eng-copy-btn').forEach(function (btn) {
  btn.addEventListener('click', function (event) {
    event.preventDefault();
    copyCaption(btn);
  });
});
